import React from 'react';

import { useHistory } from 'react-router-dom';
import { pageTitle as pageTitleService } from 'services/pageTitle';

import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import classes from './programTopHeader.module.scss';

interface Props {
    pageTitle: string;
    showBack?: boolean;
    showBackLink?: string;
    endComponent?: React.ReactNode;
}

export const ProgramTopHeader = ({ pageTitle, showBack = false, showBackLink, endComponent }: Props) => {
    const history = useHistory();
    pageTitleService.set(pageTitle);
    return (
        <div className={classes.pageTitle} id={'page-title'}>
            {showBack && (
                <MuiIcon
                    icon={'arrow_back'}
                    id={'page-title-go-back'}
                    fontSize={'3.2rem'}
                    color={'var(--text-brand-primary)'}
                    onClick={() => (showBackLink ? history.push(showBackLink) : history.goBack())}
                    className={classes.back}
                />
            )}
            <span className={classes.titleWrapper}>
                <span className={classes.title}>{pageTitle}</span>
                {endComponent !== undefined && endComponent}
            </span>
        </div>
    );
};
